import script from "./SearchBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBox.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBox.vue?vue&type=style&index=0&id=32c948e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c948e6"]])

export default __exports__